import Box from '@mui/material/Box'
import TableSort from '../tableComponents/TableSort'
import { variableName, operatorName } from "../js/constants"
import { formatDateRange, formatDayFilter } from "../js/utilityRoutines"

export default function ConhrlyTable(props) { 
  const { tabledata, sumObs, sumMiss, userParams, stnName } = props;
  const dateRange = formatDateRange(userParams);
  const dayFilter =  formatDayFilter(userParams);
  const totObs = sumObs.toLocaleString("en");
  const totMiss = sumMiss.toLocaleString("en");
  const variable = userParams.variable;
  const tableTitlePartial = "Longest runs of consecutive hours with " + variableName[userParams.variable].name + " " +
    operatorName[userParams.operator] + " " + (userParams.thresh === "T" ? "Trace" : (userParams.thresh + " " + variableName[userParams.variable].units));
  const titleText = tableTitlePartial + "<br/ >" + stnName;
  const footerText = "Based on a total of " + totObs + " hourly observations; " + 
    totMiss + " hours missing" +
    (["htindx", "wchill"].includes(variable) ? " or conditions not met for index calculation." : ".") +
    "<br />" + dateRange +
    (dayFilter ? "<br />" : "") + dayFilter + (dayFilter ? "." : "");
  const heads = [
    {text: 'index', id: 'index', invisible: true, initSort: true, sortOrder: 'asc'},
    {text: 'Rank', id: 'rank', altSort: 'index'},
    {text: 'Length of Run (hours)', id: 'val'},
    {text: 'Ending Date/Hour', id: 'dt'},
  ]

  return (
    <Box sx={{my: 1}}>
      <TableSort 
        titleText={titleText} 
        heads={heads}  
        tableNoSortData={tabledata}
        footerText={footerText}
        doNotSort={true}
      />
    </Box>
  )
}
